import { render, staticRenderFns } from "./WebhooksList.vue?vue&type=template&id=32772401&"
import script from "./WebhooksList.vue?vue&type=script&lang=js&"
export * from "./WebhooksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports